import { combineReducers } from 'redux';

const currentTab = (state: 'webhook' | 'history' = 'webhook', action: any) => {
  switch (action.type) {
    case 'WEBHOOK/CHANGE_CURRENT_TAB':
      return action.tab;
    default:
      return state;
  }
};

const modal = (state: any = { active: false, id: null }, action: any) => {
  switch (action.type) {
    case 'WEBHOOK/OPEN_MODAL':
      return { active: true, id: action.id };
    case 'WEBHOOK/CLOSE_MODAL':
      return { active: false, id: null };
    default:
      return state;
  }
};

const modalTest = (state: any = { active: false, url: {} }, action: any) => {
  switch (action.type) {
    case 'WEBHOOK/OPEN_MODAL_TEST':
      return { ...state, active: true };
    case 'WEBHOOK/CLOSE_MODAL_TEST':
      return { ...state, active: false };
    case 'WEBHOOK/SET_TEST_URL':
      return { ...state, url: action.payload };
    default:
      return state;
  }
};

export const item = (state: any = {}, action: any) => {
  switch (action.type) {
    case 'WEBHOOKQV/ITEM':
      return action.payload;
    default:
      return state;
  }
};

const initUrl = {
  product_id: -1,
  url: '',
  description: '',
};

export const url = (state: any = initUrl, action: any) => {
  switch (action.type) {
    case 'WEBHOOK/CHANGE_URL':
      return { ...action.payload };
    case 'WEBHOOK/CLEAR_URL':
      return { ...initUrl };
    default:
      return { ...state };
  }
};

export const WebhookReducer = combineReducers({
  currentTab,
  modal,
  item,
  url,
  modalTest,
});
